import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../popup/popup.component';
import { InfoService, petKeyInfo } from '../services/info.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppService } from '../services/app.service';
import { MatRadioChange } from '@angular/material/radio';

export interface Time {
  time: string;
}
export interface Amount {
  amount: string;
}
export interface AddTime {
  mode: string;
  for: string;
  feedSch: [];
  feedAmount: [];
  feedUnit: [];
  Type: [];
  feedData: feedData;
  medData: MedData;
}
interface SubmitMedData {
  description: string;
  medicationSchedules: {}[];
  id: number;
}
interface SubmitData {
  feedMethod: {};
  feedType: {};
  petFeedSchedules: {}[];
  description: string;
  id: number;
}
interface Food {
  value: string;
  viewValue: string;
}
interface feedData {
  id: number;
  description: string;
  feedAmount: { id: number };
  feedSchedule: { id: number };
  feedUnit: { id: number };
  deleted: boolean,
  type: string
}
interface MedData {
  id: number;
  description: string;
  medicationAmount: { id: number };
  medicationSchedule: { id: number };
  medicationType: { id: number };
  medicationUnit: { id: number };
  deleted: boolean,
  type: string
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  @Input() dataSource = [];
  @Input() displayedColumns = [];
  @Input() size = 0;
  @Input() type = '';
  @Output() petFeedDone = new EventEmitter<number>();
  @Output() petMedDone = new EventEmitter<number>();
  @Output() cardFeedDone = new EventEmitter<number>();
  @Output() stepperChange = new EventEmitter<number>();




  buffer = false;
  Columns: string[] = ['feedSchedule', 'feedAmount', 'feedUnit', 'description', 'Action'];
  MedColumns: string[] = ['MedSchedule', 'MedAmount', 'MedUnit', 'MedType', 'description', 'Action'];
  CardColumns: string[] = ['details', 'action'];
  disableBtn = false;
  cardData = [];
  postData = [];
  data: any = []
  feedMethodId: number;
  FeedSch: any = [];
  FeedAmt: any = [];
  FeedUnit: any = [];
  PetFeed = [];
  FeedType: any = [];
  FeedMethod: any = [];
  feedDescription: '';
  petFeedMethod: any = {};
  petFeedType: any = {};
  // Medication 
  MedSch: any = [];
  MedAmt: any = [];
  MedUnit: any = [];
  MedType: any = [];
  MedpostData = [];
  Meddata: any = []
  MedDescription = '';
  medSubmitControl = false;
  feedSubmitControl = false;
  swallSaveControl = false;
  petKeyIndex = 0;

  feedData: feedData = {
    id: 0,
    description: "",
    feedAmount: { id: 0 },
    feedSchedule: { id: 0 },
    feedUnit: { id: 0 },
    deleted: false,
    type: 'new'
  }

  MedData: MedData = {
    id: 0,
    description: "",
    medicationAmount: { id: 0 },
    medicationSchedule: { id: 0 },
    medicationType: { id: 0 },
    medicationUnit: { id: 0 },
    deleted: false,
    type: 'new'
  }



  constructor(public dialog: MatDialog, private infoService: InfoService, private appService: AppService) {
  }
  ngOnInit(): void {

    this.getPetFeed(0);
    this.getPetMed(0);
    this.getCard();
  }


  feedId: number = -1;
  currentPetName = '';
  getCard() {
    // console.log('view card');
    this.buffer = true;
    this.infoService.GetCard().subscribe((res: any) => {
      // console.log(res);
      if (res) {
        this.cardData = res.list;
        // console.log(this.cardData);
        this.appService.savedCards = res.list

        this.cardFeedDone.emit(this.cardData.length);
        
        this.buffer = false;

      }

    })
  }

  deleteCard(element: any) {
    // console.log(element);
    Swal.fire({
      title: 'Are you sure?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.buffer = true;

        this.infoService.DeleteCard(element.id).subscribe((res) => {
          // console.log(res);
          if (res) {
            Swal.fire(
              'Deleted!',
              'Your Card has been deleted.',
              'success'
            )
            this.getCard();
            this.buffer = false;

          }

        })

      }
    })


  }

  feedRefresh() {
    console.log('feed refreshing...');
    this.postData = [];
    this.data = [];
    this.petFeedMethod = {};
    this.petFeedType = {};
    this.feedDescription = '';
    this.feedId = -1;

  }

  medRefresh() {
    this.medId = -1;
    this.Meddata = [];
    this.MedpostData = [];
    this.MedDescription = '';
  }

  next() {
    // this.feedRefresh();
    if (this.infoService.petKey.length - 1 == this.petKeyIndex) {
      this.stepperChange.emit(1);
    } else {
      this.getPetFeed(this.petKeyIndex + 1);
    }
  }

  nextMed() {

    // this.medRefresh();
    if (this.infoService.petKey.length - 1 == this.petMedKeyIndex) {
      this.stepperChange.emit(1);
    } else {
      this.getPetMed(this.petMedKeyIndex + 1);
    }

  }
  nextControl = false;
  nextMedControl = false;
  pets: petKeyInfo[] = [];
  petKey;

  getPetFeed(index: number) {

    let petList = this.infoService.petKey;
    this.pets = this.infoService.petKey;
    this.petKeyIndex = index % petList.length;
    let flag = false;
    for (let i = this.petKeyIndex; i < petList.length; i++) {
      if (petList[i].ForceFeeding) {
        this.currentPetName = petList[i].name;
        if (this.infoService.petKey.length != i) {
          this.petKey = petList[i].petKey;
        }
        this.petKeyIndex = i;
        flag = true;
        break;
      }
    }

    if (!flag) {
      this.stepperChange.emit(1);
      this.petFeedDone.emit(this.data.length);
      return;
    }
    this.buffer=true;
    this.infoService.petFeed(this.petKey).subscribe((res: any) => {
      // this.PetFeed=res.

      if (res.list.length != 0) {
        this.nextControl = true;
        this.feedSubmitControl = false;
        this.petFeedMethod = res.list[0].feedMethod;
        this.petFeedType = res.list[0].feedType;
        // console.log('****pet feed ***', res);
        this.feedId = res.list[0].id;
        this.data = res.list[0].petFeedSchedules;
        this.postData = res.list[0].petFeedSchedules;
        this.feedDescription = res.list[0].description;

        if (this.infoService.petKey.length - 1 == this.petKeyIndex) {
          this.petFeedDone.emit(this.postData.length);
        }
      } else {
        this.feedRefresh();
        this.nextControl = false;

        // this.feedRefresh();
      }
      this.buffer=false;
    })
    if (index == 0) {
      this.infoService.feedSch().subscribe((res: any) => {
        this.FeedSch = res.data.content;
      })
      this.infoService.feedAmt().subscribe((res: any) => {
        this.FeedAmt = res.data.content;
      })
      this.infoService.feedUnits().subscribe((res: any) => {
        this.FeedUnit = res.data.content;
        // console.log(this.FeedUnit);
      })
      this.infoService.feedType().subscribe((res: any) => {
        // this.FeedUnit = res.data.content;
        this.FeedType = res.data.content;
        // console.log(this.FeedType, "feedtype");
        // for (let i = 0; i < res.data.content.length; i++) {
        //   // console.log(res.data.content[i].time, 'looping')
        //   this.FeedAmt.push({'amount':res.data.content[i].amount}) 
        // }
        // console.log(this.FeedAmt);
      })
      this.infoService.feedMethod().subscribe((res: any) => {
        this.FeedMethod = res.data.content;
        // console.log(this.FeedMethod, "feedtype");
      })
    }
  }
  medId: number = -1;
  petMedKeyIndex = 0;
  medKey;

  getPetMed(index: number) {
    // this.petMedKeyIndex = index;
    // let petList = this.infoService.petKey;
    // // console.log('******', petList[index], petList.length, index);


    // this.currentPetName = petList[index].name;

    // if (this.infoService.petKey.length != this.petMedKeyIndex) {
    //   this.medKey = petList[index].petKey;
    // }
    let petList = this.infoService.petKey;
    this.petMedKeyIndex = index % petList.length;

    // console.log('******', petList[index], petList.length, index);
    let flag = false;

    for (let i = this.petMedKeyIndex; i < petList.length; i++) {

      if (petList[i].ForceMedication) {
        this.currentPetName = petList[i].name;
        this.petMedKeyIndex = i;
        if (this.infoService.petKey.length != i) {
          this.medKey = petList[i].petKey;
        }
        flag = true;
        break;
      }
    }

    if (!flag) {
      this.petMedDone.emit(this.MedpostData.length);
      this.stepperChange.emit(1);
      return;
    }
    this.buffer=true;
    this.infoService.petMed(this.medKey).subscribe((res: any) => {
      // this.PetFeed=res.
      // console.log('****pet Med ***', res);
      if (res.list.length != 0) {
        this.medSubmitControl = false;
        this.nextMedControl = true;
        this.medId = res.list[0].id;
        this.Meddata = res.list[0].medicationSchedules;
        this.MedpostData = res.list[0].medicationSchedules;
        this.MedDescription = res.list[0].description;
        if (this.infoService.petKey.length - 1 == this.petMedKeyIndex) {
          this.petMedDone.emit(this.MedpostData.length);
        }
      } else {
        this.medRefresh();
        this.nextMedControl = false;
      }
      this.buffer=false;
    })
    if (index == 0) {
      
      this.infoService.MedSch().subscribe((res: any) => {
        // data/content
        this.MedSch = res.data.content;
        // console.log(this.MedSch,'medsch!!!');

      })
      this.infoService.MedAmt().subscribe((res: any) => {
        // data/content
        this.MedAmt = res.data.content;
        // console.log(this.MedAmt,'medAmount!!!');
      })
      this.infoService.MedUnit().subscribe((res: any) => {
        this.MedUnit = res.data.content;
        // console.log(this.MedUnit,'medUnit!!!');
      })
      this.infoService.MedType().subscribe((res: any) => {
        this.MedType = res.data.content;
        // console.log(this.MedType,'medType!!!');
      })
    }
  }
  getPetKey() {
    console.log(this.FeedType, this.FeedMethod)
    console.log(this.infoService.petKey);

  }

  OpenMedDialog() {

    const dialogRef = this.dialog.open(PopupComponent, {
      height: '550px', width: '550px',
      data: { mode: 'Add', for: 'med', feedSch: this.MedSch, feedAmount: this.MedAmt, feedUnit: this.MedUnit, medData: this.MedData, Type: this.MedType }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
      if (result) {
        this.swallSaveControl = true;
        this.medSubmitControl = true;
        for (let i = 0; i < this.MedUnit.length; i++) {
          if (result.unit == this.MedUnit[i].id) {
            let unit = this.MedUnit.slice(i, i + 1);
            this.MedData.medicationUnit = unit[0];
            // console.log(this.feedData);
          }
        }
        for (let i = 0; i < this.MedSch.length; i++) {
          if (result.schedule == this.MedSch[i].id) {
            let schedule = this.MedSch.slice(i, i + 1);
            this.MedData.medicationSchedule = schedule[0];
          }
        }
        for (let i = 0; i < this.MedAmt.length; i++) {
          if (result.amount == this.MedAmt[i].id) {
            let amount = this.MedAmt.slice(i, i + 1);
            this.MedData.medicationAmount = amount[0];
          }
        }
        for (let i = 0; i < this.MedType.length; i++) {
          if (result.type == this.MedType[i].id) {
            let type = this.MedType.slice(i, i + 1);
            this.MedData.medicationType = type[0];
          }
        }
        // this.MedData.description=result.description;
        // console.log(this.MedData);
        this.addMedTime();

      }
    })
  }
  editMed(element: any) {
    let elementObj = element;

    // console.log(elementObj);

    const EditDialog = this.dialog.open(PopupComponent, {
      height: '550px', width: '550px',
      data: { mode: 'Edit', for: 'med', feedSch: this.MedSch, feedAmount: this.MedAmt, feedUnit: this.MedUnit, medData: elementObj, Type: this.MedType }

    });

    EditDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this.swallSaveControl = true;

        this.medSubmitControl = true;
        this.nextMedControl = false;

        // console.log(result, 'result', this.MedSch);
        for (let i = 0; i < this.MedSch.length; i++) {

          if (result.schedule == this.MedSch[i].id) {
            let schedule = this.MedSch.slice(i, i + 1);
            // console.log(schedule);

            for (let i = 0; i < this.MedpostData.length; i++) {
              if (element.id == this.MedpostData[i].id) {
                this.MedpostData[i].medicationSchedule = schedule[0];
                // console.log(this.FeedAmt, 'loopUnit', unit, this.MedpostData);
              }
            }
          }
        }
        for (let i = 0; i < this.MedAmt.length; i++) {

          if (result.amount == this.MedAmt[i].id) {

            let amount = this.MedAmt.slice(i, i + 1);
            for (let i = 0; i < this.MedpostData.length; i++) {
              if (element.id == this.MedpostData[i].id) {
                this.MedpostData[i].medicationAmount = amount[0];
                // console.log(this.FeedAmt, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
        for (let i = 0; i < this.MedUnit.length; i++) {
          if (result.unit == this.MedUnit[i].id) {
            let unit = this.MedUnit.slice(i, i + 1);
            // console.log(unit);
            for (let i = 0; i < this.MedpostData.length; i++) {
              if (element.id == this.MedpostData[i].id) {
                this.MedpostData[i].medicationUnit = unit[0];
                // console.log(this.FeedUnit, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
        for (let i = 0; i < this.MedType.length; i++) {
          if (result.type == this.MedType[i].id) {
            let type = this.MedType.slice(i, i + 1);
            for (let i = 0; i < this.MedpostData.length; i++) {
              if (element.id == this.MedpostData[i].id) {
                this.MedpostData[i].medicationType = type[0];
                // console.log(this.FeedUnit, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
      }

    });
  }
  openDialog(): void {
    // console.log('new dialog', this.feedData);

    const dialogRef = this.dialog.open(PopupComponent, {
      height: '500px', width: '550px',
      data: { mode: 'Add', for: 'feed', feedSch: this.FeedSch, feedAmount: this.FeedAmt, feedUnit: this.FeedUnit, feedData: this.feedData }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
      if (result) {
        this.nextControl = false;
        let duplicate = false;
        this.swallSaveControl = true;

        this.data.forEach(element => {
          if (element.feedSchedule.id == result.schedule) {
            Swal.fire({
              title: 'Feeding already exists',
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              }
            })

            duplicate = true;
          }
        });
        if (!duplicate) {
          this.feedSubmitControl = true;
          for (let i = 0; i < this.FeedUnit.length; i++) {
            if (result.unit == this.FeedUnit[i].id) {
              let unit = this.FeedUnit.slice(i, i + 1);
              this.feedData.feedUnit = unit[0];
              // console.log(this.feedData);
            }
          }
          for (let i = 0; i < this.FeedSch.length; i++) {
            if (result.schedule == this.FeedSch[i].id) {
              let schedule = this.FeedSch.slice(i, i + 1);
              this.feedData.feedSchedule = schedule[0];
            }
          }
          for (let i = 0; i < this.FeedAmt.length; i++) {
            if (result.amount == this.FeedAmt[i].id) {
              let amount = this.FeedAmt.slice(i, i + 1);
              this.feedData.feedAmount = amount[0];
            }
          }
          this.addTime();
        }
      }

    });
  }
  edit(element: any) {
    // console.log(element, this.FeedUnit, this.FeedSch);
    let elementObj = element;
    let schedule = this.FeedSch;
    let amount = this.FeedAmt;
    let unit = this.FeedUnit.slice(0);
    // console.log(this.data);

    const EditDialog = this.dialog.open(PopupComponent, {
      height: '500px', width: '550px',
      data: { mode: 'Edit', for: 'feed', feedSch: schedule, feedAmount: amount, feedUnit: unit, feedData: elementObj }
    });

    EditDialog.afterClosed().subscribe((result: any) => {

      if (result) {
        this.feedSubmitControl = true;
        this.nextControl = false;
        this.swallSaveControl = true;

        // console.log(result, 'result');
        for (let i = 0; i < schedule.length; i++) {
          if (result.schedule == schedule[i].id) {
            schedule = schedule.slice(i, i + 1);
            for (let i = 0; i < this.postData.length; i++) {
              if (element.id == this.postData[i].id) {
                this.postData[i].feedSchedule = schedule[0];
                // console.log(this.FeedAmt, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
        for (let i = 0; i < amount.length; i++) {
          if (result.amount == amount[i].id) {
            amount = amount.slice(i, i + 1);
            for (let i = 0; i < this.postData.length; i++) {
              if (element.id == this.postData[i].id) {
                this.postData[i].feedAmount = amount[0];
                // console.log(this.FeedAmt, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
        for (let i = 0; i < unit.length; i++) {
          if (result.unit == unit[i].id) {
            unit = unit.slice(i, i + 1);
            for (let i = 0; i < this.postData.length; i++) {
              if (element.id == this.postData[i].id) {
                this.postData[i].feedUnit = unit[0];
                // console.log(this.FeedUnit, 'loopUnit', unit, this.postData);
              }
            }
          }
        }
      }
    });
  }

  deleteMed(element: any) {



    for (let i = 0; i < this.MedpostData.length; i++) {
      // console.log(this.data[i].id);

      if (this.MedpostData[i].id == element.id) {
        this.MedpostData[i].deleted = true;
        this.nextMedControl = false;
        this.swallSaveControl = true;
        this.medSubmitControl = true;
      }
    }

    this.Meddata = this.MedpostData.filter((el) => {
      return el.deleted == false;
    })
    if (this.Meddata.length <= 0) {

    }
    this.Meddata = [...this.Meddata];
  }

  delete(element: any) {
    // console.log(element.id);
    for (let i = 0; i < this.postData.length; i++) {
      // console.log(this.data[i].id);

      if (this.postData[i].id == element.id) {
        this.postData[i].deleted = true;
        this.feedSubmitControl = true;
        this.nextControl = false;
        this.swallSaveControl = true;

      }
    }
    this.data = this.postData.filter((el) => {
      return el.deleted == false;
    })
    this.data = [...this.data];
    // console.log(this.data, this.postData);

  }
  addMedTime() {
    let size = this.MedpostData.length + 1;
    this.MedData.id = size;
    // this.data.push(this.feedData);
    this.MedpostData.push(this.MedData);
    this.Meddata = [...this.MedpostData];
    this.nextMedControl = false;
    this.swallSaveControl = true;

    this.Meddata = this.MedpostData.filter((el) => {
      return el.deleted == false;
    })

    this.refresh();
    // console.log(this.Meddata, this.MedpostData);
  }
  addTime() {
    // console.log(this.feedData, this.FeedUnit);
    let size = this.postData.length + 1;
    this.feedData.id = size;
    // this.data.push(this.feedData);
    this.postData.push(this.feedData);
    this.swallSaveControl = true;

    this.data = [...this.postData];
    this.data = this.postData.filter((el) => {
      return el.deleted == false;
    })
    this.nextControl = false;
    this.refresh();
    // console.log(this.data, this.postData);
  }
  refresh() {
    this.feedData = {
      id: 0,
      description: "",
      feedAmount: { id: 0 },
      feedSchedule: { id: 0 },
      feedUnit: { id: 0 },
      deleted: false,
      type: 'new'
    }
    this.MedData = {
      id: 0,
      description: "",
      medicationAmount: { id: 0 },
      medicationSchedule: { id: 0 },
      medicationType: { id: 0 },
      medicationUnit: { id: 0 },
      deleted: false,
      type: 'new'
    }
    this.submitMedData = {
      description: '',
      medicationSchedules: {}[''],
      id: -1
    }
    this.submitData = {
      feedMethod: {},
      feedType: {},
      petFeedSchedules: {}[''],
      description: '',
      id: -1
    }
  }
  feedChanged() {
    this.feedSubmitControl = true;
    this.nextControl = false;
    this.swallSaveControl = true;

  }
  medChange() {
    this.medSubmitControl = true;
    this.nextMedControl = false;
    this.swallSaveControl = true;

  }
  // Submission Feed and Medication 

  submitData: SubmitData = {
    feedMethod: {},
    feedType: {},
    petFeedSchedules: {}[''],
    description: '',
    id: -1
  }
  feedError = '';
  isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0
  }
  submit() {

    for (let i = 0; i < this.FeedMethod.length; i++) {
      if (this.petFeedMethod.id == this.FeedMethod[i].id) {
        this.submitData.feedMethod = this.FeedMethod[i];
      }
    }
    for (let i = 0; i < this.FeedType.length; i++) {
      if (this.petFeedType.id == this.FeedType[i].id) {
        this.submitData.feedType = this.FeedType[i];
      }
    }
    if (this.isObjectEmpty(this.submitData.feedType)) {
      console.log("select type");
      this.feedError = 'Feeding Type Missing *';
      return;
    }
    if (this.isObjectEmpty(this.submitData.feedMethod)) {
      console.log("select type");
      this.feedError = 'Feeding Method Missing *';
      return;
    } else {
      this.feedError = '';
    }

    for (let i = 0; i < this.postData.length; i++) {
      if (this.postData[i].type == 'new') {
        delete this.postData[i].deleted;
        delete this.postData[i].id;
        delete this.postData[i].type;
      }
    }

    this.submitData.id = this.feedId;
    this.swallSaveControl = false;

    this.submitData.description = this.feedDescription;
    this.submitData.petFeedSchedules = this.postData;
    // console.log(this.submitData);

    this.infoService.FeedPost(this.submitData, this.petKeyIndex).subscribe((res) => {
      // console.log(res);

      this.feedId = -1;

      if (this.infoService.petKey.length - 1 == this.petKeyIndex) {
        this.stepperChange.emit(1);
        this.petFeedDone.emit(this.data.length);

      } else {
        this.feedRefresh();

        this.getPetFeed(this.petKeyIndex + 1);
      }
      this.feedSubmitControl = false;


    })
    // console.log(this.submitData);
  }
  submitMedData: SubmitMedData = {
    description: '',
    medicationSchedules: {}[''],
    id: -1
  }

  submitMed() {
    // console.log(this.MedpostData);

    for (let i = 0; i < this.MedpostData.length; i++) {
      if (this.MedpostData[i].type == 'new') {
        delete this.MedpostData[i].deleted;
        delete this.MedpostData[i].id;
        delete this.MedpostData[i].type;
      }
    }
    this.submitMedData.description = this.MedDescription;
    this.submitMedData.id = this.medId;
    this.submitMedData.medicationSchedules = this.MedpostData;
    this.medSubmitControl = false;
    this.swallSaveControl = false;

    this.infoService.MedPost(this.submitMedData, this.petMedKeyIndex).subscribe((res) => {
      // console.log(res);

      if (res) {
        this.medId = -1;
        if (this.infoService.petKey.length - 1 == this.petMedKeyIndex) {
          this.petMedDone.emit(this.MedpostData.length);
          this.stepperChange.emit(1);
        } else {
          this.medRefresh();
          this.getPetMed(this.petMedKeyIndex + 1);
        }
      }
    }, error => {
      console.log("error", error);
    });
    // console.log(this.submitMedData,'medication result');
    // this.refresh();

  }

  handleChange(change: MatRadioChange) {
    this.appService.currentCard = change.value
  }

  ngOnChange(): void {
  }

}
